import { render } from "./BerichtEntscheidungslisteAPNRW.pug?vue&type=template&id=531c4268&lang=pug"
import script from "./BerichtEntscheidungslisteAPNRW.js?vue&type=script&lang=js"
export * from "./BerichtEntscheidungslisteAPNRW.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__